export interface ServerPermissions {
  server_manager: boolean;   // Full server settings control
  server_assistant: boolean; // Member management, channel creation
  create_invite: boolean;    // Create invite link perms
  mic_perms: boolean;        // Mic permitted (if false, permanently muted)
  voice_activity: boolean;   // Voice activity (if false, push to talk forced)
}

export interface ServerRole {
  id: string;
  vault_id: string;
  name: string;
  color: string;
  position: number;
  permissions: ServerPermissions;
  created_at?: string;
}

export interface ServerMemberRole {
  user_id: string;
  vault_id: string;
  role_id: string;
}

export function getHighestRole(userRoles: ServerRole[]): ServerRole | null {
  if (!userRoles || userRoles.length === 0) return null;
  return userRoles.reduce((highest, role) => 
    role.position < highest.position ? role : highest
  );
}

export function hasPermission(userRoles: ServerRole[], permission: keyof ServerPermissions): boolean {
  if (!userRoles || userRoles.length === 0) return false;
  return userRoles.some(role => role.permissions?.[permission] === true);
}
